export const CLIENT_ACTIONABLE_STATUSES = ['PendingManager', 'PendingClient'];

export const CLIENT_RESEND_COOLDOWN_DAYS = 5;
